export const inputNames = [
    { name: "Español", id: "es", readOnly: false},
    { name: "Namuy-wam", id: "gum", readOnly: false },
];
  